import _ from 'common-tools/LodashHelper'
import moment from 'moment'

export const NewCategoryData = (freshData) => {
  // Create array of all data value
  let outerData = {}
  let catData = []
  let allChartData = []
  let TemperatureValues = []
  let SystolicValues = []
  let DiastolicValues = []
  let O2SaturationValues = []
  let PulseValues = []
  let PainValues = []
  let RespirationValues = []
  let BloodSugarValues = []
  let WeightValues = []
  let HeightValues = []

  _.forEach(freshData, (a) => {
    _.forEach(a.VitalSignList, (b) => {
      if (b.Temperature) {
        TemperatureValues.push(b.Temperature)
      }
      if (b.BPSystolic) {
        SystolicValues.push(b.BPSystolic)
      }
      if (b.BPDiastolic) {
        DiastolicValues.push(b.BPDiastolic)
      }
      if (b.O2Saturation) {
        O2SaturationValues.push(b.O2Saturation)
      }
      if (b.Pulse) {
        PulseValues.push(b.Pulse)
      }
      if (b.Pain) {
        PainValues.push(b.Pain)
      }
      if (b.Respiration) {
        RespirationValues.push(b.Respiration)
      }
      if (b.BloodSugar) {
        BloodSugarValues.push(b.BloodSugar)
      }
      if (b.Weight) {
        WeightValues.push(b.Weight)
      }
      if (b.Height) {
        HeightValues.push(b.Height)
      }
    })
  })

  // reshape Temperature data info
  let TemperatureTopData = []
  let TemperatureDrillData = []
  let TemperatureDrillObj = {}
  let TemperatureData = {}
  let DrillTemperatureData = []
  let TemperatureValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillTemperatureData = []
    TemperatureData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].Temperature) {
        // Top Data
        TemperatureData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        TemperatureData.y = a.VitalSignList[0].Temperature
        const newTemperatureData = _.clone(TemperatureData)
        TemperatureTopData.push(newTemperatureData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.Temperature) {
          DrillTemperatureData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.Temperature])
          TemperatureValuePerDocumentDate.push(b.Temperature)
        }
      })
      if (DrillTemperatureData.length > 1) {
        // Top Data
        TemperatureData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        TemperatureData.drilldown = `Temperature${a.DocumentDate}(${a.UserName})`
        TemperatureData.y = TemperatureValuePerDocumentDate[TemperatureValuePerDocumentDate.length - 1]
        const newTemperatureData = _.clone(TemperatureData)
        TemperatureTopData.push(newTemperatureData)
        // Drill Data
        TemperatureDrillObj.id = `Temperature${a.DocumentDate}(${a.UserName})`
        TemperatureDrillObj.name = 'Temperature'
        TemperatureDrillObj.data = _.clone(DrillTemperatureData)
        const newTemperatureDrillObj = _.clone(TemperatureDrillObj)
        TemperatureDrillData.push(newTemperatureDrillObj)
      }
    }
  })
  // reshape Systolic data info
  let BPSystolicTopData = []
  let BPSystolicDrillData = []
  let BPSystolicDrillObj = {}
  let BPSystolicData = {}
  let DrillBPSystolicData = []
  let BPSystolicValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillBPSystolicData = []
    BPSystolicData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].BPSystolic) {
        // Top Data
        BPSystolicData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        BPSystolicData.y = a.VitalSignList[0].BPSystolic
        const newBPSystolicData = _.clone(BPSystolicData)
        BPSystolicTopData.push(newBPSystolicData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.BPSystolic) {
          DrillBPSystolicData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.BPSystolic])
          BPSystolicValuePerDocumentDate.push(b.BPSystolic)
        }
      })
      if (DrillBPSystolicData.length > 1) {
        // Top Data
        BPSystolicData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        BPSystolicData.drilldown = `BPSystolic${a.DocumentDate}(${a.UserName})`
        BPSystolicData.y = BPSystolicValuePerDocumentDate[BPSystolicValuePerDocumentDate.length - 1]
        const newBPSystolicData = _.clone(BPSystolicData)
        BPSystolicTopData.push(newBPSystolicData)
        // Drill Data
        BPSystolicDrillObj.id = `BPSystolic${a.DocumentDate}(${a.UserName})`
        BPSystolicDrillObj.name = 'BPSystolic'
        BPSystolicDrillObj.data = _.clone(DrillBPSystolicData)
        const newBPSystolicDrillObj = _.clone(BPSystolicDrillObj)
        BPSystolicDrillData.push(newBPSystolicDrillObj)
      }
    }
  })
  // reshape Diastolic data info
  let BPDiastolicTopData = []
  let BPDiastolicDrillData = []
  let BPDiastolicDrillObj = {}
  let BPDiastolicData = {}
  let DrillBPDiastolicData = []
  let BPDiastolicValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillBPDiastolicData = []
    BPDiastolicData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].BPDiastolic) {
        // Top Data
        BPDiastolicData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        BPDiastolicData.y = a.VitalSignList[0].BPDiastolic
        const newBPDiastolicData = _.clone(BPDiastolicData)
        BPDiastolicTopData.push(newBPDiastolicData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.BPDiastolic) {
          DrillBPDiastolicData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.BPDiastolic])
          BPDiastolicValuePerDocumentDate.push(b.BPDiastolic)
        }
      })
      if (DrillBPDiastolicData.length > 1) {
        // Top Data
        BPDiastolicData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        BPDiastolicData.drilldown = `BPDiastolic${a.DocumentDate}(${a.UserName})`
        BPDiastolicData.y = BPDiastolicValuePerDocumentDate[BPDiastolicValuePerDocumentDate.length - 1]
        const newBPDiastolicData = _.clone(BPDiastolicData)
        BPDiastolicTopData.push(newBPDiastolicData)
        // Drill Data
        BPDiastolicDrillObj.id = `BPDiastolic${a.DocumentDate}(${a.UserName})`
        BPDiastolicDrillObj.name = 'BPDiastolic'
        BPDiastolicDrillObj.data = _.clone(DrillBPDiastolicData)
        const newBPDiastolicDrillObj = _.clone(BPDiastolicDrillObj)
        BPDiastolicDrillData.push(newBPDiastolicDrillObj)
      }
    }
  })
  // reshape O2Sat data info
  let O2SaturationTopData = []
  let O2SaturationDrillData = []
  let O2SaturationDrillObj = {}
  let O2SaturationData = {}
  let DrillO2SaturationData = []
  let O2SaturationValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillO2SaturationData = []
    O2SaturationData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].O2Saturation) {
        // Top Data
        O2SaturationData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        O2SaturationData.y = a.VitalSignList[0].O2Saturation
        const newO2SaturationData = _.clone(O2SaturationData)
        O2SaturationTopData.push(newO2SaturationData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.O2Saturation) {
          DrillO2SaturationData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.O2Saturation])
          O2SaturationValuePerDocumentDate.push(b.O2Saturation)
        }
      })
      if (DrillO2SaturationData.length > 1) {
        // Top Data
        O2SaturationData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        O2SaturationData.drilldown = `O2Saturation${a.DocumentDate}(${a.UserName})`
        O2SaturationData.y = O2SaturationValuePerDocumentDate[O2SaturationValuePerDocumentDate.length - 1]
        const newO2SaturationData = _.clone(O2SaturationData)
        O2SaturationTopData.push(newO2SaturationData)
        // Drill Data
        O2SaturationDrillObj.id = `O2Saturation${a.DocumentDate}(${a.UserName})`
        O2SaturationDrillObj.name = 'O2Saturation'
        O2SaturationDrillObj.data = _.clone(DrillO2SaturationData)
        const newO2SaturationDrillObj = _.clone(O2SaturationDrillObj)
        O2SaturationDrillData.push(newO2SaturationDrillObj)
      }
    }
  })
  // reshape Pulse data info
  let PulseTopData = []
  let PulseDrillData = []
  let PulseDrillObj = {}
  let PulseData = {}
  let DrillPulseData = []
  let PulseValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillPulseData = []
    PulseData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].Pulse) {
        // Top Data
        PulseData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        PulseData.y = a.VitalSignList[0].Pulse
        const newPulseData = _.clone(PulseData)
        PulseTopData.push(newPulseData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.Pulse) {
          DrillPulseData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.Pulse])
          PulseValuePerDocumentDate.push(b.Pulse)
        }
      })
      if (DrillPulseData.length > 1) {
        // Top Data
        PulseData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        PulseData.drilldown = `Pulse${a.DocumentDate}(${a.UserName})`
        PulseData.y = PulseValuePerDocumentDate[PulseValuePerDocumentDate.length - 1]
        const newPulseData = _.clone(PulseData)
        PulseTopData.push(newPulseData)
        // Drill Data
        PulseDrillObj.id = `Pulse${a.DocumentDate}(${a.UserName})`
        PulseDrillObj.name = 'Pulse'
        PulseDrillObj.data = _.clone(DrillPulseData)
        const newPulseDrillObj = _.clone(PulseDrillObj)
        PulseDrillData.push(newPulseDrillObj)
      }
    }
  })
  // reshape Pain data info
  let PainTopData = []
  let PainDrillData = []
  let PainDrillObj = {}
  let PainData = {}
  let DrillPainData = []
  let PainValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillPainData = []
    PainData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].Pain) {
        // Top Data
        PainData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        PainData.y = a.VitalSignList[0].Pain
        const newPainData = _.clone(PainData)
        PainTopData.push(newPainData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.Pain) {
          DrillPainData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.Pain])
          PainValuePerDocumentDate.push(b.Pain)
        }
      })
      if (DrillPainData.length > 1) {
        // Top Data
        PainData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        PainData.drilldown = `Pain${a.DocumentDate}(${a.UserName})`
        PainData.y = PainValuePerDocumentDate[PainValuePerDocumentDate.length - 1]
        const newPainData = _.clone(PainData)
        PainTopData.push(newPainData)
        // Drill Data
        PainDrillObj.id = `Pain${a.DocumentDate}(${a.UserName})`
        PainDrillObj.name = 'Pain'
        PainDrillObj.data = _.clone(DrillPainData)
        const newPainDrillObj = _.clone(PainDrillObj)
        PainDrillData.push(newPainDrillObj)
      }
    }
  })
  // reshape Resp data info
  let RespirationTopData = []
  let RespirationDrillData = []
  let RespirationDrillObj = {}
  let RespirationData = {}
  let DrillRespirationData = []
  let RespirationValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillRespirationData = []
    RespirationData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].Respiration) {
        // Top Data
        RespirationData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        RespirationData.y = a.VitalSignList[0].Respiration
        const newRespirationData = _.clone(RespirationData)
        RespirationTopData.push(newRespirationData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.Respiration) {
          DrillRespirationData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.Respiration])
          RespirationValuePerDocumentDate.push(b.Respiration)
        }
      })
      if (DrillRespirationData.length > 1) {
        // Top Data
        RespirationData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        RespirationData.drilldown = `Respiration${a.DocumentDate}(${a.UserName})`
        RespirationData.y = RespirationValuePerDocumentDate[RespirationValuePerDocumentDate.length - 1]
        const newRespirationData = _.clone(RespirationData)
        RespirationTopData.push(newRespirationData)
        // Drill Data
        RespirationDrillObj.id = `Respiration${a.DocumentDate}(${a.UserName})`
        RespirationDrillObj.name = 'Respiration'
        RespirationDrillObj.data = _.clone(DrillRespirationData)
        const newRespirationDrillObj = _.clone(RespirationDrillObj)
        RespirationDrillData.push(newRespirationDrillObj)
      }
    }
  })
  // reshape Blood Sugar data info
  let BloodSugarTopData = []
  let BloodSugarDrillData = []
  let BloodSugarDrillObj = {}
  let BloodSugarData = {}
  let DrillBloodSugarData = []
  let BloodSugarValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillBloodSugarData = []
    BloodSugarData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].BloodSugar) {
        // Top Data
        BloodSugarData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        BloodSugarData.y = a.VitalSignList[0].BloodSugar
        const newBloodSugarData = _.clone(BloodSugarData)
        BloodSugarTopData.push(newBloodSugarData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.BloodSugar) {
          DrillBloodSugarData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.BloodSugar])
          BloodSugarValuePerDocumentDate.push(b.BloodSugar)
        }
      })
      if (DrillBloodSugarData.length > 1) {
        // Top Data
        BloodSugarData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        BloodSugarData.drilldown = `BloodSugar${a.DocumentDate}(${a.UserName})`
        BloodSugarData.y = BloodSugarValuePerDocumentDate[BloodSugarValuePerDocumentDate.length - 1]
        const newBloodSugarData = _.clone(BloodSugarData)
        BloodSugarTopData.push(newBloodSugarData)
        // Drill Data
        BloodSugarDrillObj.id = `BloodSugar${a.DocumentDate}(${a.UserName})`
        BloodSugarDrillObj.name = 'BloodSugar'
        BloodSugarDrillObj.data = _.clone(DrillBloodSugarData)
        const newBloodSugarDrillObj = _.clone(BloodSugarDrillObj)
        BloodSugarDrillData.push(newBloodSugarDrillObj)
      }
    }
  })
  // reshape Weight data info
  let WeightTopData = []
  let WeightDrillData = []
  let WeightDrillObj = {}
  let WeightData = {}
  let DrillWeightData = []
  let WeightValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillWeightData = []
    WeightData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].Weight) {
        // Top Data
        WeightData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        WeightData.y = a.VitalSignList[0].Weight
        const newWeightData = _.clone(WeightData)
        WeightTopData.push(newWeightData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.Weight) {
          DrillWeightData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.Weight])
          WeightValuePerDocumentDate.push(b.Weight)
        }
      })
      if (DrillWeightData.length > 1) {
        // Top Data
        WeightData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        WeightData.drilldown = `Weight${a.DocumentDate}(${a.UserName})`
        WeightData.y = WeightValuePerDocumentDate[WeightValuePerDocumentDate.length - 1]
        const newWeightData = _.clone(WeightData)
        WeightTopData.push(newWeightData)
        // Drill Data
        WeightDrillObj.id = `Weight${a.DocumentDate}(${a.UserName})`
        WeightDrillObj.name = 'Weight'
        WeightDrillObj.data = _.clone(DrillWeightData)
        const newWeightDrillObj = _.clone(WeightDrillObj)
        WeightDrillData.push(newWeightDrillObj)
      }
    }
  })
  // reshape Height data info
  let HeightTopData = []
  let HeightDrillData = []
  let HeightDrillObj = {}
  let HeightData = {}
  let DrillHeightData = []
  let HeightValuePerDocumentDate = []
  _.forEach(freshData, (a) => {
    DrillHeightData = []
    HeightData = {}
    // console.log({ visitarraylength: a.VitalSignList.length })
    if (a.VitalSignList.length === 1) {
      if (a.VitalSignList[0].Height) {
        // Top Data
        HeightData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        HeightData.y = a.VitalSignList[0].Height
        const newHeightData = _.clone(HeightData)
        HeightTopData.push(newHeightData)
      }
    } else if (a.VitalSignList.length > 1) {
      _.forEach(a.VitalSignList, (b) => {
        if (b.Height) {
          DrillHeightData.push([moment.tz(b.TimeTaken, 'UTC').format('LT'), b.Height])
          HeightValuePerDocumentDate.push(b.Height)
        }
      })
      if (DrillHeightData.length > 1) {
        // Top Data
        HeightData.name = `${moment.tz(a.DocumentDate, 'UTC').format('MMM-DD')} (${a.UserName})`
        HeightData.drilldown = `Height${a.DocumentDate}(${a.UserName})`
        HeightData.y = HeightValuePerDocumentDate[HeightValuePerDocumentDate.length - 1]
        const newHeightData = _.clone(HeightData)
        HeightTopData.push(newHeightData)
        // Drill Data
        HeightDrillObj.id = `Height${a.DocumentDate}(${a.UserName})`
        HeightDrillObj.name = 'Height'
        HeightDrillObj.data = _.clone(DrillHeightData)
        const newHeightDrillObj = _.clone(HeightDrillObj)
        HeightDrillData.push(newHeightDrillObj)
      }
    }
  })

  // Create object for cat and chart
  if (TemperatureValues.length > 0) {
    let TempObjCat = {}
    let TempObjData = {}
    TempObjCat.name = 'Temperature'
    TempObjCat.CurrentValue = TemperatureValues[TemperatureValues.length - 1]
    TempObjCat.Icon = 'temperature-high'
    TempObjCat.ToolTip = 'Temperature (F)'
    TempObjCat.Color = 'info'
    TempObjData.name = 'Temperature'
    TempObjData.data = TemperatureTopData
    TempObjData.drillData = TemperatureDrillData
    catData.push(TempObjCat)
    allChartData.push(TempObjData)
  }
  if (SystolicValues.length > 0) {
    let BPObjCat = {}
    let BPObjData = {}
    BPObjCat.name = 'Blood Pressure'
    BPObjCat.CurrentValue = `${SystolicValues[SystolicValues.length - 1]} / ${DiastolicValues[DiastolicValues.length - 1]}`
    BPObjCat.Icon = 'file-medical-alt'
    BPObjCat.ToolTip = 'Blood Pressure (mmHg)'
    BPObjCat.Color = 'info'
    BPObjData.name = 'Blood Pressure'
    BPObjData.Sysdata = BPSystolicTopData
    BPObjData.Sysdrilldata = BPSystolicDrillData
    BPObjData.Diadata = BPDiastolicTopData
    BPObjData.Diadrilldata = BPDiastolicDrillData
    catData.push(BPObjCat)
    allChartData.push(BPObjData)
  }
  if (O2SaturationValues.length > 0) {
    let O2SatObjCat = {}
    let O2SatObjData = {}
    O2SatObjCat.name = 'O2Saturation'
    O2SatObjCat.CurrentValue = O2SaturationValues[O2SaturationValues.length - 1]
    O2SatObjCat.Icon = 'dewpoint'
    O2SatObjCat.ToolTip = 'O2Saturation (%)'
    O2SatObjCat.Color = 'info'
    O2SatObjData.name = 'O2Saturation'
    O2SatObjData.data = O2SaturationTopData
    O2SatObjData.drillData = O2SaturationDrillData
    catData.push(O2SatObjCat)
    allChartData.push(O2SatObjData)
  }
  if (PulseValues.length > 0) {
    let PulseObjCat = {}
    let PulseObjData = {}
    PulseObjCat.name = 'Pulse'
    PulseObjCat.CurrentValue = PulseValues[PulseValues.length - 1]
    PulseObjCat.Icon = 'heartbeat'
    PulseObjCat.ToolTip = 'Pulse (bpm)'
    PulseObjCat.Color = 'info'
    PulseObjData.name = 'Pulse'
    PulseObjData.data = PulseTopData
    PulseObjData.drillData = PulseDrillData
    catData.push(PulseObjCat)
    allChartData.push(PulseObjData)
  }
  if (PainValues.length > 0) {
    let PainObjCat = {}
    let PainObjData = {}
    PainObjCat.name = 'Pain'
    PainObjCat.CurrentValue = PainValues[PainValues.length - 1]
    PainObjCat.Icon = PainValues[PainValues.length - 1] > 5 ? 'grimace' : 'meh-rolling-eyes'
    PainObjCat.ToolTip = 'Pain (Scale 1-10)'
    PainObjCat.Color = PainValues[PainValues.length - 1] > 5 ? 'danger' : 'info'
    PainObjData.name = 'Pain'
    PainObjData.data = PainTopData
    PainObjData.drillData = PainDrillData
    catData.push(PainObjCat)
    allChartData.push(PainObjData)
  }
  if (RespirationValues.length > 0) {
    let RespObjCat = {}
    let RespObjData = {}
    RespObjCat.name = 'Respiration'
    RespObjCat.CurrentValue = RespirationValues[RespirationValues.length - 1]
    RespObjCat.Icon = 'lungs'
    RespObjCat.ToolTip = 'Respiration (BPM)'
    RespObjCat.Color = 'info'
    RespObjData.name = 'Respiration'
    RespObjData.data = RespirationTopData
    RespObjData.drillData = RespirationDrillData
    catData.push(RespObjCat)
    allChartData.push(RespObjData)
  }
  if (BloodSugarValues.length > 0) {
    let BSObjCat = {}
    let BSObjData = {}
    BSObjCat.name = 'Blood Sugar'
    BSObjCat.CurrentValue = BloodSugarValues[BloodSugarValues.length - 1]
    BSObjCat.Icon = 'file-medical'
    BSObjCat.ToolTip = 'Blood Sugar (mg/dL)'
    BSObjCat.Color = 'info'
    BSObjData.name = 'Blood Sugar'
    BSObjData.data = BloodSugarTopData
    BSObjData.drillData = BloodSugarDrillData
    catData.push(BSObjCat)
    allChartData.push(BSObjData)
  }
  if (WeightValues.length > 0) {
    let WeightObjCat = {}
    let WeightObjData = {}
    WeightObjCat.name = 'Weight'
    WeightObjCat.CurrentValue = WeightValues[WeightValues.length - 1]
    WeightObjCat.Icon = 'weight'
    WeightObjCat.ToolTip = 'Weight (lbs)'
    WeightObjCat.Color = 'info'
    WeightObjData.name = 'Weight'
    WeightObjData.data = WeightTopData
    WeightObjData.drillData = WeightDrillData
    catData.push(WeightObjCat)
    allChartData.push(WeightObjData)
  }
  if (HeightValues.length > 0) {
    let HeightObjCat = {}
    let HeightObjData = {}
    HeightObjCat.name = 'Height'
    HeightObjCat.CurrentValue = HeightValues[HeightValues.length - 1]
    HeightObjCat.Icon = 'line-height'
    HeightObjCat.ToolTip = 'Height (in)'
    HeightObjCat.Color = 'info'
    HeightObjData.name = 'Height'
    HeightObjData.data = HeightTopData
    HeightObjData.drillData = HeightDrillData
    catData.push(HeightObjCat)
    allChartData.push(HeightObjData)
  }
  const newCatData = _.clone(catData)
  const newAllchartData = _.clone(allChartData)
  outerData.CategoryData = newCatData
  outerData.AllChartData = newAllchartData
  return outerData
}

export const TemperatureOptions = [
  { Text: 'Axilla (Armpit)', Value: 'Axilla (Armpit)' },
  { Text: 'Forehead', Value: 'Forehead' },
  { Text: 'Oral (Mouth)', Value: 'Oral (Mouth)' },
  { Text: 'Rectal (Anal)', Value: 'Rectal (Anal)' },
  { Text: 'Tympanic (Ear Canal)', Value: 'Tympanic (Ear Canal)' }
]

export const BloodPressureOptions = [
  { Text: 'Lying Down', Value: 'Lying Down' },
  { Text: 'Sitting Down', Value: 'Sitting Down' },
  { Text: 'Standing Up', Value: 'Standing Up' }
]

export const PulseOptions = [
  { Text: 'Apical (Heart)', Value: 'Apical (Heart)' },
  { Text: 'Brachial (Arm)', Value: 'Brachial (Arm)' },
  { Text: 'Carotid (Neck)', Value: 'Carotid (Neck)' },
  { Text: 'Femoral (Thigh)', Value: 'Femoral (Thigh)' },
  { Text: 'Pedal (Foot)', Value: 'Pedal (Foot)' },
  { Text: 'Popliteal (Leg)', Value: 'Popliteal (Leg)' },
  { Text: 'Radial (Wrist)', Value: 'Radial (Wrist)' },
  { Text: 'Temporal (Temple)', Value: 'Temporal (Temple)' }
]

export const BloodSugarOptions = [
  { Text: '2 Hour Postprandial', Value: '2 Hour Postprandial' },
  { Text: '8 Hour Fasting', Value: '8 Hour Fasting' },
  { Text: 'Glycohemoglobin A1c', Value: 'Glycohemoglobin A1c' },
  { Text: 'Oral Glucose Tolerance', Value: 'Oral Glucose Tolerance' },
  { Text: 'Random', Value: 'Random' }
]

export const VitalSignPageMode = {
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  Unchanged: 'Unchanged'
}
